export const MANAGE_APPOINTMENTS = "#ManageAppointments";
